export const MEMBERSHIP_PRODUCT_CATEGORY_NAMES = [
  "Protect Wash Club",
  "Protect+ Wash Club",
  "Shine Wash Club",
];
export const INDIVIDUAL_WASH = "Individual Wash";
export const CHECKOUT_FORM_KEY = "checkout_form";
